import React, { useState } from 'react';
import { Grid, Tabs, Tab, Box, Button, Typography } from '@mui/material';
import { AdminGoals, FacultyGoals } from './GoalsDashboard';
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../storageService';
import { AssignedGoals, MyGoals } from './GoalsDashboardStudent';

const Goals: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const userDetails = getUserDetails();
  const userType = userDetails?.Type || ''; // could be 'Student', 'Admin', 'Faculty'

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = [
    { label: 'Admin Goals', value: 0, component: <AdminGoals /> },
    { label: 'Faculty Goals', value: 1, component: <FacultyGoals /> },
  ];
  const studenttabs = [
    { label: 'Assigned Goals', value: 0, component: <AssignedGoals /> },
    { label: 'My Goals', value: 1, component: <MyGoals /> },
  ];

  return (
    <Grid container>
      <Box
        sx={{
          marginTop: 1,
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: 2,
          width: '100%',
          height: 'calc(81vh)',
        }}
      >
        {userType === 'Student' ? (
           <>
           <Box display="flex" justifyContent="space-between" alignItems="center">
             <Tabs
               value={activeTab}
               onChange={handleTabChange}
               textColor="inherit"
               TabIndicatorProps={{ style: { backgroundColor: '#2C58E8', height: '2px' } }}
             >
               {studenttabs.map((tab) => (
                 <Tab
                   key={tab.value}
                   label={tab.label}
                   value={tab.value}
                   sx={{
                     textTransform: 'none',
                     color: 'black',
                     fontWeight: activeTab === tab.value ? 500 : 'normal',
                     fontSize: '16px',
                     '&.Mui-selected': {
                       color: 'black',
                     },
                   }}
                 />
               ))}
             </Tabs>

             {activeTab === 1 && (
               <Button
                 variant="contained"
                 sx={{ textTransform: 'none', backgroundColor: '#2C58E8', color: 'white' }}
                 onClick={() => navigate('/goals/add-goals')}
               >
                 Add Goal
               </Button>
             )}
           </Box>

           <Box mt={2} sx={{ height: '48vh' }}>
             {studenttabs.find((tab) => tab.value === activeTab)?.component}
           </Box>
         </>
        ) : (
         
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="inherit"
                TabIndicatorProps={{ style: { backgroundColor: '#2C58E8', height: '2px' } }}
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    sx={{
                      textTransform: 'none',
                      color: 'black',
                      fontWeight: activeTab === tab.value ? 500 : 'normal',
                      fontSize: '16px',
                      '&.Mui-selected': {
                        color: 'black',
                      },
                    }}
                  />
                ))}
              </Tabs>

              {activeTab === 1 && (
                <Button
                  variant="contained"
                  sx={{ textTransform: 'none', backgroundColor: '#2C58E8', color: 'white' }}
                  onClick={() => navigate('/goals/add-goals')}
                >
                  Add Goal
                </Button>
              )}
            </Box>

            <Box mt={2} sx={{ height: '65vh', overflowY: 'auto' }}>
              {tabs.find((tab) => tab.value === activeTab)?.component}
            </Box>
          </>
        )}
      </Box>
    </Grid>
  );
};

export default Goals;
